import React, { useEffect, useState } from "react";

import { Box, createStyles, Input, Text } from "@mantine/core";
import AlertModal from "../../../components/AlertModal";
import { useDisclosure } from "@mantine/hooks";
import { useSelector } from "react-redux";
import StaffTable from "../../../components/StaffTable";
import StaffModal from "../../../containers/StaffModal";
import { getAllStaff } from "../../../services/staff";
import { TrackPageView } from "../../../config/mixpanelConfig";
import { getAllFacilities } from "../../../services";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { NewAddButton } from "../../../components/AddButton/NewAddButton";
import { FaPlus } from "react-icons/fa6";
import { IconSearch } from "@tabler/icons-react";
import useDebounce from "../../../utils/useDebounce";
import CustomBillingPagination from "../../../components/Pagination/CustomBillingPagination";
import { useNavigate } from "react-router-dom";
import { CiSettings } from "react-icons/ci";
import RemainingCounts from "../../../components/RemainingCounts";
import swal from "sweetalert";
import { upgradePlanAddOn } from "../../../services/subscription";
import { getDashboardCounts } from "../../../services/dashboard";
import { showError } from "../../../utils";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflowX: "auto",
    backgroundColor: "#F5F5F5",
  },
  btn: {
    marginLeft: "auto",
    marginTop: 50,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: 10,
    "@media (max-width: 600px)": {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  mymodal: {
    width: 818,
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
  },
  mwd: {
    width: "100%",
  },
  tabContainer: {
    display: "flex",
    minWidth: "260px",
    height: "40px",
  },
  activeTabBg: {
    background: "#fff !important",
    borderBottom: "3px solid #000",
    color: "#262626",
  },
  activeTab: {
    display: "flex",
    alignItems: "center",
    background: "#fff",
    fontFamily: "Inter",
    padding: "5px 10px",
    cursor: "pointer",
    color: "#979797",
    "& p": {
      margin: "0",
      fontWeight: "600",
      color: "#979797",
    },
    "& img": {
      width: "24px",
      marginRight: "5px",
    },
  },
  inActiveTab: {
    display: "flex",
    fontFamily: "Inter",
    alignItems: "center",
    background: "#fff",
    padding: "5px 10px",
    cursor: "pointer",
    color: "#979797",
    "& p": {
      color: "#979797",
      margin: "0",
      fontWeight: "600",
    },
    "& img": {
      width: "24px",
      marginRight: "5px",
    },
  },
  table: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    // height: "100vh",
    borderRadius: "12px",
    padding: "0 10px",
    background: "#FFFFFF",
    border: "1px solid #E5E5E5",
    marginTop: "10px",
  },
  search: {
    // border: "1px solid #E5E5E5",
    background: "#FFF",
    // padding: "10px 0",
    marginBottom: "10px",
    borderRadius: "12px",
  },
  title: {
    color: "#171717",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    marginTop: "15px",
  },
  searchInput: {
    width: "100%",
    marginBlock: "10px",
    borderRadius: "12px",
    "& :focus-within": {
      border: "1px solid #D0D5DD",
    },
    "& :focus": {
      border: "1px solid #D0D5DD",
    },
    "& :hover": {
      border: "1px solid #D0D5DD",
    },
    "& :active": {
      border: "1px solid #D0D5DD",
    },
    "& :focus-visible": {
      border: "1px solid #D0D5DD",
    },
  },
}));
const Staff = () => {
  const { classes } = useStyles();
  const [isopen, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const { staffCount } = useSelector((state) => state.staff);
  const { dashboardCounts, loadingCount } = useSelector((state) => state.dashboard);
  const [selectedTab, setSelectedTab] = useState(true);
  const { profile } = useSelector((state) => {
    return state?.profile;
  });
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearch = useDebounce(searchTerm, 2000);

  const [isStaffModalOpen, { open: openStaffModal, close: closeStaffModal }] =
    useDisclosure(false);

  useEffect(() => {
    getAllStaff(currentPage, true, selectedTab, "");
  }, [currentPage, selectedTab]);

  useEffect(() => {
    getAllStaff(currentPage, true, selectedTab, "");
    getAllFacilities();
  }, []);

  useEffect(() => {
    TrackPageView("Staff");
  }, []);

  const handleAddStaff = async () => {
    if (dashboardCounts?.remainingStaffCount <= 0) {
      if (profile.user?.role === "admin") {
        return (
          showError(
            "You have reached your quota upgrade subscription to increase limits contact your admin to upgrade",
            "error"

          )
        )
      }
      if (profile?.subscription?.packageId?.name === "Starter") {
        await swal({
          text: `You have reached your quota upgrade subscription to increase limits`,
          icon: "warning",
          dangerMode: true,
        });
      } else {
        const willContinue = await swal({
          title: `Do you wish to continue?`,
          text: `You have exceeded your current plan limit. Additional staff will cost $${
            profile?.user?.additionalStaffCost ??
            profile?.subscription?.packageId?.additionalStaff
          } per month. This charge will be added to your monthly subscription cost`,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: "Cancel",
            confirm: {
              text: "Confirm",
              value: true,
              closeModal: false,
            },
          },
        });

        if (willContinue) {
          await upgradePlanAddOn({ type: "staff" });
          swal.close();
          navigate(`/home/staff/staff/add`);
        }
      }
    } else {
      navigate(`/home/staff/staff/add`);
    }
  };

  const handleAddContractor = () => {
    navigate(`/home/add-contractor`);
  };

  const handleStaffManageAttendance = () => {
    navigate(`/home/staff/manage-attendance/all`);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleTabChange = (tab) => {
    setCurrentPage(1);
    setSelectedTab(tab);
    setSearchTerm("");
  };

  useEffect(() => {
    if (debouncedSearch) {
      getAllStaff(currentPage, true, null, debouncedSearch);
    } else {
      getAllStaff(currentPage, true, null, "");
    }
  }, [debouncedSearch, getAllStaff]);

  return (
    <Box className={classes.content}>
      <AppNavbar title="Staff" profile={profile} />
      <AlertModal isopen={isopen} close={() => setOpen(false)} />
      <StaffModal
        save={setOpen}
        title={"Add New Staff"}
        opened={isStaffModalOpen}
        onclose={closeStaffModal}
        selectedTab={selectedTab}
      />

      <Box px={20}>
        <Box mt={20}>
          <RemainingCounts
            text={"Staff Remaining"}
            count={dashboardCounts?.remainingStaffCount}
            loadingCount={loadingCount}
          />
        </Box>

        <Box className={classes.btn}>
          <Box className={classes.tabContainer}>
            <Box
              className={`${classes.activeTab} ${
                selectedTab ? classes.activeTabBg : ""
              }`}
              onClick={() => handleTabChange(true)}
            >
              <Text fw={500} ff={"Inter"}>
                Active
              </Text>
            </Box>
            <Box
              className={`${classes.inActiveTab} ${
                !selectedTab ? classes.activeTabBg : ""
              }`}
              onClick={() => handleTabChange(false)}
            >
              <Text fw={500} ff={"Inter"}>
                Inactive
              </Text>
            </Box>
          </Box>
          <div style={{ display: "flex", gap: 10 }}>
            {/* <NewAddButton
              title="Add contractor"
              icon={<FaPlus />}
              onClick={handleAddContractor}
              color="#FFAF4A"
              textColor="#000"
              variant="filled"
              borderColor="none"
            /> */}
            <NewAddButton
              title="Add Staff"
              icon={<FaPlus />}
              onClick={handleAddStaff}
              color="#FFAF4A"
              textColor="#000"
              variant="filled"
              borderColor="none"
            />
            <NewAddButton
              title="Manage Attendance"
              icon={<CiSettings size={25} />}
              color="#fff"
              textColor="#000"
              variant="filled"
              borderColor="#D0D5DD"
              onClick={handleStaffManageAttendance}
            />
          </div>
        </Box>
        <Text className={classes.title}>All Staff</Text>

        <Box className={classes.table}>
          <Box className={classes.search}>
            <Input
              icon={<IconSearch />}
              placeholder="Search Staff Name"
              className={classes.searchInput}
              radius={"md"}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Box>
          <StaffTable selectedTab={selectedTab} />
          <CustomBillingPagination
            data={staffCount}
            itemsPerPage={10}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Staff;
